export const yearsAvailable = (data) => {
  const years = new Set([String(new Date().getFullYear())]);
  data.visited.forEach((v) => (v.trips || []).forEach((t) => t.date && years.add(t.date.slice(0, 4))));
  data.goals.forEach((g) => g.done && g.completed_at && years.add(g.completed_at.slice(0, 4)));
  return [...years].sort((a, b) => b.localeCompare(a));
};

export const yearStats = (data, year) => {
  const trips = data.visited
    .flatMap((v) => (v.trips || []).map((t) => ({ ...t, country: v.country })))
    .sort((a, b) => a.date.localeCompare(b.date));
  const firstSeen = {};
  trips.forEach((t) => { if (!firstSeen[t.country]) firstSeen[t.country] = t.date; });
  const inYear = trips.filter((t) => t.date.startsWith(year));
  const countries = [];
  inYear.forEach((t) => { if (!countries.some((c) => c.country === t.country)) countries.push({ country: t.country, date: t.date }); });
  const cityMap = {};
  inYear.forEach((t) => (t.cities || []).forEach((c) => { (cityMap[t.country] ||= new Set()).add(c); }));
  const cityVisited = Object.entries(cityMap).map(([country, set]) => ({ country, cities: [...set], places: data.visited.find((v) => v.country === country)?.places || [] }));
  const cities = cityVisited.reduce((s, v) => s + v.cities.length, 0);
  const firstTime = countries.filter((c) => firstSeen[c.country]?.startsWith(year)).length;
  const dreams = data.goals.filter((g) => g.done && g.completed_at?.startsWith(year)).sort((a, b) => a.completed_at.localeCompare(b.completed_at));
  return { countries, cities, cityVisited, firstTime, dreams };
};
